/**
 * # Strings helpers
 * > Some utilities about strings (capitalize etc)
 *
 * @author nicolas husson <nicolas@kffein.com>
 */

export default class StringsHelper {
  /**
   * @returns {String} 1st letter of each words capitalized
   * @param {String} string
   */
  static capitalize(string:string):string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * @returns {String} file extention
   * @param {String} filename
   */
  static getFileExtension(filename:string):string {
    const search = /[.]/.exec(filename)
    if (search) {
      const extract = /[^.]+$/.exec(filename);
      return extract ? extract[0] : '';
    }
    return '';
  }

  /**
   * @returns {String} where `\n` replaced by `<br>`
   * @param {String} string - string to format
   */
  static nl2br(string:string):string | null {
    if (typeof string !== 'string') return null;

    return (string).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
  }

  /**
   * @returns {String} slugifyed
   * @param {String} string - string to format
   * @see https://gist.github.com/mathewbyrne/1280286
   */
  static slugify(text:string):string | null {
    return slugify(text)
  }

  /**
   * @returns {String} without p tags
   * @param {String} string - wysiwyg value with p tags that we don't need
   */
  static safeTitle(text:string):string | null {
    return text.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "");
  }
}

//@todo export direct function vs static = easierto import
export function slugify(text:string):string | null {
  if (typeof text !== 'string') return null;

  return text.toString().toLowerCase()
    /*eslint-disable */
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
    /* eslint-enable */
}
